import { Component, inject, OnInit, Input, TemplateRef, WritableSignal, signal } from '@angular/core';
import { DecimalPipe, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginLogout } from '../../../view-logs-components/login-logout/login-logout';
import { CreateView } from '../global/create-view/create-view';
import { UpdateView } from '../global/update-view/update-view';
import { NgbPopover, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import {
   NgbPaginationModule,
   NgbTypeaheadModule,
   NgbCollapseModule,
   NgbDropdownModule,
   NgbModal,
   NgbActiveModal,
   ModalDismissReasons,
   NgbOffcanvas, OffcanvasDismissReasons,
   NgbAlertModule,
   NgbDatepickerModule,
   NgbDateStruct,
   NgbTooltipModule,
   NgbToastModule
} from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { AuditLogService } from '../../../services/audit-log.service';
import * as moment from 'moment';
// import { DateFormatPipe } from '../pipes/date-format.pipe';
// import { TextTruncatePipe } from '../pipes/text-truncate.pipe';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

import { ToastService } from '../../../services/toast-service';
import { ToastsContainer } from '../../../containers/toasts-container.component';
import { IndexedDBService } from '../../../services/indexed-db.service'; // Import the IndexedDB service
import { TimezonePipe } from '../../../pipes/timezone.pipe';

export interface ChangedField {
   old_value: any;
   new_value: any;
}

const FILTER_PAG_REGEX = /[^0-9]/g;


export interface Log {
   id: number;
   action: string;
   model: string;
   user: string;
   date_time: string;
   ip: string;
   created_by: string;
   created_at: string;
   updated_by: string;
   updated_at: string;
   super_admin_login: boolean;
   object_id: string;
   user_agent: string;
   _collapsed: boolean;
   new_fields?: { [key: string]: any };
   changed_fields?: { [key: string]: ChangedField };
}

@Component({
   selector: 'ngbd-logs',
   standalone: true,
   imports: [
      LoginLogout,
      CreateView,
      UpdateView,
      NgbAlertModule,
      NgbDatepickerModule,
      NgbDropdownModule,
      CommonModule,
      NgbCollapseModule,
      FormsModule,
      NgbTypeaheadModule,
      NgbPaginationModule,
      HttpClientModule,
      NgbPopoverModule,
      // DateFormatPipe,
      NgbTooltipModule,
      TimezonePipe
      ,
      ToastsContainer
   ],
   templateUrl: './logs.html',
   styleUrls: ['./logs.scss'],
})
export class Logs implements OnInit {


   toastService = inject(ToastService);
   page = 1;
   pageSize = 30;
   collectionSize = 82;
   logsData: Log[] = [];
   paginatedLogsData: Log[] = []; // Add this line
   searchQuery = '';
   dateFilter: NgbDateStruct | undefined;
   // Filter panel toggle state
   showFilter = false;
   timeOptions = [
      { label: 'Last 30 minutes', value: '30' },
      { label: 'Last 1 hour', value: '1' },
      { label: 'Last 4 hours', value: '4' },
      { label: 'Last 12 hours', value: '12' },
      { label: 'Last 24 hours', value: '24' },
      { label: 'Custom Range', value: 'custom' }
   ];
   selectedRange = '30'; // default
   selectedRangeLabel = 'Last 30 minutes';
   // custom values
   customStartDate: string = '';
   customStartTime: string = '00:00';
   customEndDate: string = '';
   customEndTime: string = '00:00';


   private offcanvasService = inject(NgbOffcanvas);
   closeResult: WritableSignal<string> = signal('');

   pages = [
      { key: 'Booking', value: 'Booking', route: '/booking-view', passKey: 'object_id' },
      { key: 'SchoolMyTeacher', value: 'My List', route: '/school-my-teacher', passKey: 'object_id' },
      { key: 'School', value: 'School Profile', route: '/school-profile', passKey: 'object_id' },
      // Teacher Side
      { key: 'Teacher', value: 'Teacher Profile', route: '/teacher-profile', passKey: 'object_id' },
      { key: 'InviteTeacher', value: 'Invite Teacher', route: '/invite-teacher', passKey: 'object_id' },
      { key: 'InviteSchool', value: 'Invite School', route: '/invite-school', passKey: 'object_id' }
   ];


   // Filter criteria
   filter = {
      action: 'loginlogout',
      model: 'Booking',
      user: '',
      date: ''
   };
   isLoading: boolean = false;
   // rowDataForModal: Log | null = null; // Initialize rowDataForModal to null

   toasts: string[] = [];
   showTask: boolean = true;
   allLogsData: Log[] = [];

   actionsToShow: {
      [key: string]: {
         showCollapse: boolean;
         showinfoPage: boolean;
      };
   } = {};

   timeRangeFilter: { type: string; value: string | { start: string; end: string } } = {
      type: 'mins',
      value: this.selectedRange
   }


   constructor(private auditLogService: AuditLogService, private modalService: NgbModal, private router: Router) {
      // Constructor is now empty as initialization is moved to ngOnInit
      const now = new Date();
      const start = new Date(now);
      const end = new Date(now);
      start.setDate(start.getDate() + -1);

      // Format as YYYY-MM-DD
      this.customStartDate = start.toISOString().split('T')[0];
      this.customEndDate = end.toISOString().split('T')[0];
   }

   ngOnInit(): void {
      this.isLoading = true; // Set loading state to true

      // Check if filters exist in IndexedDB
      Promise.all([
         IndexedDBService.get('logsFilters'),
         IndexedDBService.get('timeRangeFilter')
      ]).then(([savedFilters, savedTimeRange]) => {
         if (savedFilters) {
            this.filter = savedFilters; // Use the saved filters
         }
         if (savedTimeRange) {
            this.timeRangeFilter = savedTimeRange;
            const foundOption = this.timeOptions.find(option => option.value === savedTimeRange.value);
            this.selectedRange = foundOption ? foundOption.value : 'custom';
            this.selectedRangeLabel = this.findLabel(this.selectedRange);

         }
         // Fetch logs using the current filters and time range
         this.fetchAuditLogs();
      });
   }



   findLabel(value: string): string {
      const option = this.timeOptions.find(opt => opt.value === value);
      return option ? option.label : 'Custom Range';
   }

   openEnd(contentCanvas: TemplateRef<any>) {
      this.offcanvasService.open(contentCanvas, { position: 'end' });
   }


   async fetchAuditLogs(): Promise<void> {
      this.showTask = true;
      // console.log(this.timeRangeFilter)
      this.setActionsBtns();
      this.isLoading = true; // Show loader
      try {
         let paginatedFilter = { page_no: this.page, page_size: this.pageSize };
         const data: any = await firstValueFrom(
            this.auditLogService.fetchAuditLogs(this.filter.action, this.filter.model, paginatedFilter, JSON.stringify(this.timeRangeFilter))
         );
         this.logsData = data.data; // Fetch all data
         this.allLogsData = data.data; // Store all logs data
         this.collectionSize = data.total_count;
         // this.updatePagination();


         // After fetching logsData
         this.logsData.forEach(log => log._collapsed = false);
      } catch (error) {
         console.error('Error fetching audit logs:', error);
         this.toastService.show('Error fetching audit logs. Please try again later.', {
            classname: 'bg-danger text-light',
            delay: 5000,
         });
      } finally {
         this.isLoading = false; // Hide loader
      }
   }

   async onLogsActionClick(selectedAction: string): Promise<void> {
      this.page = 1;
      this.filter.action = selectedAction; // Update the filter with the selected action
      // if(selectedAction =="loginlogout"){
      //    this.filter.model = '';
      // }
      // Save the updated filter to IndexedDB
      await IndexedDBService.save('logsFilters', this.filter);
      // console.log('Filters saved to IndexedDB:', this.filter);

      // Fetch logs with the updated filter
      await this.fetchAuditLogs();
   }

   async onLogsModelClick(selectedModel: string): Promise<void> {
      this.page = 1;
      if (this.filter.action === 'create' || this.filter.action === 'update') {
         this.filter.model = selectedModel; // Update the filter with the selected model

         // console.log(this.filter)
         // Save the updated filter to IndexedDB
         await IndexedDBService.save('logsFilters', this.filter);
         // console.log('Filters saved to IndexedDB:', this.filter);

         // Fetch logs with the updated filter
         await this.fetchAuditLogs();
      }
   }

   onRefreshClick(): void {
      this.isLoading = true; // Set loading state to true

      // Save the current filter to IndexedDB
      IndexedDBService.save('logsFilters', this.filter).then(() => {
         // console.log('Filters saved to IndexedDB:', this.filter);
         this.fetchAuditLogs(); // Trigger a refresh of the logs
      });
   }

   // async updatePagination(): Promise<void> {
   //    let filteredByTask: any[] = [];
   //    if (!this.showTask) {
   //       filteredByTask = this.logsData
   //          .filter(log => log.updated_by != 'Task');
   //    } else {
   //       filteredByTask = this.logsData;
   //    }
   //    const startIndex = (this.page - 1) * this.pageSize;
   //    const endIndex = startIndex + this.pageSize;
   //    this.paginatedLogsData = filteredByTask.slice(startIndex, endIndex);
   // }

   async onSearchClick(): Promise<void> {
      this.page = 1;
      if (!this.searchQuery || this.searchQuery.trim() === '') {
         this.toastService.show('Search query is empty. Please enter a valid search term.', {
            classname: 'bg-warning text-dark',
            delay: 3000,
         });
         return;
      }

      const trimmedQuery = this.searchQuery.trim();

      // Regex for email and UUID (v4 format)
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const uuidRegex =
         /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      
      const schoolNameRegex = /^[a-zA-Z\s]+$/;

      let searchType: 'username' | 'object_id' | 'school_name' | null = null;

      if (emailRegex.test(trimmedQuery)) {
         searchType = 'username';
      } else if (uuidRegex.test(trimmedQuery)) {
         searchType = 'object_id';
      } else if (schoolNameRegex.test(trimmedQuery)) {
         searchType = 'school_name';
      } else {
         this.toastService.show('Enter a valid school name.', {
            classname: 'bg-warning text-dark',
            delay: 3000,
         });
         return;
      }

      this.isLoading = true;
      try {
         let paginatedFilter = { page_no: this.page, page_size: this.pageSize };
         const response: any = await firstValueFrom(
            this.auditLogService.searchLogs(this.filter.action, this.filter.model, trimmedQuery, searchType, paginatedFilter, JSON.stringify(this.timeRangeFilter))
         );
         this.logsData = response.data; // Fetch all data
         this.collectionSize = response.data.length;
         // this.updatePagination();


         // After fetching logsData
         this.logsData.forEach(log => log._collapsed = false);
         console.log('Search results:', response);
      } catch (error) {
         console.error('Error during search:', error);
      } finally {
         this.isLoading = false;
      }
   }

   navigateToLogsView(log: any): void {
      console.log(log);
      const pageObj = this.pages.find(page => page.key === log.model);
      const route = pageObj?.route;
      console.log(route);
      if (route) {
         this.router.navigate([route], {
            queryParams: { id: log[pageObj.passKey], action: log.model }
         });
         return;
      }
   }


   ngOnDestroy(): void {
      this.toastService.clear(); // Clear toasts on component destruction
   }

   isObject(value: any): boolean {
      return value && typeof value === 'object' && !Array.isArray(value);
   }

   onPageChange(page: number): void {
      // console.log(page)
      this.page = page;
      this.fetchAuditLogs();
      // this.updatePagination();
   }

   onShowTaskToggle() {
      this.showTask = !this.showTask;
      // this.updatePagination();
      // Additional logic for when showTask is enabled and model is 'Booking' 
      // this.updatePagination();
      this.updateLogsByShowTask();
   }

   updateLogsByShowTask() {
      if (this.showTask) {
         // Show task-related logs
         this.logsData = this.allLogsData;
      } else {
         this.logsData = this.allLogsData.filter(log => log.updated_by !== 'Task');
      }
   }

   setActionsBtns() {
      // this.actionsToShow = [
      //   { type: 'loginLogout', showCollapse: this.filter.action === 'loginlogout', showinfoPage: this.filter.action !== 'loginlogout' },
      //   { type: 'create', showCollapse: this.filter.action === 'create' && this.filter.model !== 'Booking', showinfoPage: this.filter.action === 'create' && this.filter.model == 'Booking' },
      //   { type: 'update', showCollapse: this.filter.action === 'update' && this.filter.model !== 'Booking', showinfoPage: this.filter.action === 'update' && this.filter.model == 'Booking' }
      // ];
      this.actionsToShow = {
         loginlogout: {
            showCollapse: this.filter.action === 'loginlogout',
            showinfoPage: this.filter.action !== 'loginlogout'
         },
         create: {
            showCollapse: (this.filter.action === 'create' && this.filter.model !== 'Booking' &&
               this.filter.model !== 'SchoolMyTeacher' && this.filter.model !== 'School' &&
               this.filter.model !== 'Teacher' && this.filter.model !== 'InviteTeacher' &&
               this.filter.model !== 'InviteSchool'),
            showinfoPage: (
               this.filter.action === 'create' &&
               (this.filter.model == 'Booking' || this.filter.model == 'SchoolMyTeacher' ||
                  this.filter.model == 'School' || this.filter.model == 'Teacher' ||
                  this.filter.model == 'InviteTeacher' || this.filter.model == 'InviteSchool')
            )
         },
         update: {
            showCollapse: (this.filter.action === 'update' && this.filter.model !== 'Booking' &&
               this.filter.model !== 'SchoolMyTeacher' && this.filter.model !== 'School' &&
               this.filter.model !== 'Teacher' && this.filter.model !== 'InviteTeacher' &&
               this.filter.model !== 'InviteSchool'),
            showinfoPage: (
               this.filter.action === 'update' &&
               (this.filter.model == 'Booking' || this.filter.model == 'SchoolMyTeacher' ||
                  this.filter.model == 'School' || this.filter.model == 'Teacher' ||
                  this.filter.model == 'InviteTeacher' || this.filter.model == 'InviteSchool')
            )
         }
      };
      // console.log('Actions to show:', this.actionsToShow);
   }

   onClearFilters(): void {
      this.searchQuery = '';
      this.fetchAuditLogs();
   }

   selectPage(page: string) {
      // this.page = parseInt(page, 10) || 1;
      console.log(page)
   }

   formatInput(input: HTMLInputElement) {
      let page = input.value.replace(FILTER_PAG_REGEX, '');
      const pageNumber = parseInt(page);
      if (Math.ceil(this.collectionSize / this.pageSize) < pageNumber && !isNaN(pageNumber)) {
         this.toastService.show('Out of range — please select a valid page.', {
            classname: 'bg-warning text-dark',
            delay: 3000,
         });
      } else if (!isNaN(pageNumber)) {
         this.page = pageNumber;
         this.fetchAuditLogs();
      }
   }

   // when radio changes
   // onRangeChange(option: any, pop: any) {
   //       this.selectedRangeLabel = option.label;
   // }

   // when Apply is clicked (for custom)
   applySelection(pop: any) {
      if (this.selectedRange === 'custom' && this.customStartDate && this.customStartTime && this.customEndDate && this.customEndTime) {
         this.selectedRangeLabel = `Custom: ${this.customStartDate} ${this.customStartTime} - ${this.customEndDate} ${this.customEndTime}`;
      }
      pop.close();
   }

   async applyRange(popover?: NgbPopover) {
      this.page = 1;
      const selectedOption = this.timeOptions.find(option => option.value === this.selectedRange);
      if (selectedOption) {
         this.selectedRangeLabel = selectedOption.label;
      }

      if (this.selectedRange === 'custom') {
         // console.log(this.customStartDate);
         this.timeRangeFilter.type = 'custom';
         this.timeRangeFilter.value = {
            start: `${this.customStartDate} ${this.customStartTime}`,
            end: `${this.customEndDate} ${this.customEndTime}`
         };
      } else if (Number(this.selectedRange) > 24) {
         // console.log(this.selectedRange);
         this.timeRangeFilter.type = 'mins';
         this.timeRangeFilter.value = this.selectedRange;
      } else {
         this.timeRangeFilter.type = 'hours';
         this.timeRangeFilter.value = this.selectedRange;
      }
      popover?.close(); // safe call
      await IndexedDBService.save('timeRangeFilter', this.timeRangeFilter);
      this.fetchAuditLogs();
   }


}


